import unescape from 'lodash/unescape'

export const useMeta = (params: {
  author?: string
  publisher?: string
  title?: string
  description?: string
  keywords?: string[]
  image?: string
  type?: string
  canonical?: string
}) => {
  const { siteUrl } = useEnvVariables()

  const author = unescape(params.author) || 'RisparmiaTu'
  const publisher = unescape(params.publisher) || 'RisparmiaTu'
  const title =
    params.title === 'RisparmiaTu'
      ? params.title
      : `${params.title ? unescape(params.title).replace(/\r?\n|\r/g, '') : ''} | RisparmiaTu`
  const description = params.description ? unescape(params.description).replace(/\r?\n|\r/g, '') : 'comparatore offerte'
  const type = unescape(params.type) || 'website'
  const keywords = params.keywords || [
    'comparatore',
    'risparmio',
    'energia',
    'gas',
    'telefonia',
    'telefonica',
    'telefonico',
    'telefonico',
    'assicurazione',
    'assicurazioni',
    'bolletta',
    'risparmio',
    'offerta',
    'offerte',
    'contratto',
    'scelta',
  ]
  const image = params.image || `${siteUrl}/images/social.jpg`

  useHead({
    title,
    base: { href: '/' },
    htmlAttrs: { lang: 'it' },
    meta: [
      // Keywords
      { name: 'keywords', content: [...new Set(keywords)] },
      { property: 'keywords', content: [...new Set(keywords)] },

      // Locale alternative
      { property: 'og:locale:alternate', content: 'en', key: 'en' },

      // Author and copyright
      { name: 'author', content: author },
      { name: 'publisher', content: publisher },
      { name: 'copyright', content: author },

      // OpenGraph data (Most widely used)
      { property: 'og:title', content: title },
      { property: 'og:site_name', content: title },
      // The list of types is available here: http://ogp.me/#types
      { property: 'og:type', content: type },
      // Should the the same as your canonical link, see below.
      { property: 'og:url', content: siteUrl },
      { property: 'og:image', content: image },
      // Often the same as your meta description, but not always.
      { property: 'og:description', content: description },

      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: siteUrl },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      // {name: 'twitter:creator', content: '@alligatorio'},
      { name: 'twitter:image:src', content: image },

      // Google / Schema.org markup:
      { name: 'name', content: title },
      { name: 'description', content: description },
      { name: 'image', content: image },

      // Google site verification
      { name: 'google-site-verification', content: import.meta.env.VITE_GOOGLE_SITE_VERIFICATION },
    ],
    link: [
      { rel: 'canonical', href: params.canonical || siteUrl },
      { rel: 'icon', type: 'image/png', href: computed(() => '/favicon.png') },
    ],
  })
}
